import * as React from 'react';
import { Button, Flex, Link, Box } from '@flightstats/airframe-react';
import styles from './travelerForgotCard.module.css';
import { NoWrapParagraph } from '../../components/cirium/NoWrapParagraph';
import { CiriumCard } from '../../components/cards/CiriumCard';

type TravelerForgotSuccessCardProps = {
  email: string;
};

const Description: React.FC<{ email: string }> = ({ email }) => (
  <NoWrapParagraph>
    Your username and a new password has been sent to{' '}
    <NoWrapParagraph bold inline>
      {email}
    </NoWrapParagraph>
  </NoWrapParagraph>
);

export const TravelerForgotSuccessCard: React.FC<TravelerForgotSuccessCardProps> = ({
  email,
}) => {
  return (
    <CiriumCard
      title="Password Reset"
      description={<Description email={email} />}
    >
      <Flex className={styles.flexCenter}>
      <NoWrapParagraph className={`${styles.paddingY20} ${styles.textAlignCenter}`}>
          Click the button to initiate the process.
        </NoWrapParagraph>
        <Box className={styles.marginTop20}>
          <Link href="/traveler/login">
            <Button>RETURN TO LOGIN</Button>
          </Link>
        </Box>
      </Flex>
    </CiriumCard>
  );
};